import { ErrorToast, SuccessToast } from "../components/toastify";
import { setShowPreloader } from "../store/activePage";
import { AxiosGetMethod } from "../helpers/customAxios";

const handleExportReport = async (event_id, dispatch) => {
  dispatch(setShowPreloader(true));
  const ExportReport = await AxiosGetMethod(
    `customer/event/export?event_id=${event_id}`
  );
  dispatch(setShowPreloader(false));

  if (ExportReport.status === 201 && ExportReport.data?.data?.html) {
    const blob = new Blob([ExportReport.data.data.html], { type: 'text/html' });
    const fileUrl = URL.createObjectURL(blob);
    window.open(fileUrl, "_blank");
    SuccessToast("Report print view opened.");
    return true;
  } else {
    ErrorToast(ExportReport.data?.message || "Unable to open report print view.");
    return false;
  }
};

export default handleExportReport;
